"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircuitBreakerError = void 0;
var shared_1 = require("@cian/peperrors/shared");
var CircuitBreakerError = /** @class */ (function (_super) {
    __extends(CircuitBreakerError, _super);
    function CircuitBreakerError(api) {
        var _this = _super.call(this, { type: 'CircuitBreakerError', domain: 'http-api.circuit-breaker', message: api }) || this;
        Object.setPrototypeOf(_this, CircuitBreakerError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, CircuitBreakerError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return CircuitBreakerError;
}(shared_1.GenericError));
exports.CircuitBreakerError = CircuitBreakerError;
//# sourceMappingURL=circuitBreakerError.js.map